"use strict";
/// <reference path="irep.js"/>
/* jshint newcap */
IREP.leaderboard = (function () {
    var options;
    var countryCode, storeChainId, geoCode, cultureCode, jPieChartStatusLevels, storage, categoryChanged, currentLeaderTimer, map, badgesApi, trainingQualityApi, passingPercentageApi, legendsApi;
    var leaderboard_template;
    var badgesPending, trainingQualityPending, passingPercentagePending, legendsPending;

    var init = function (leaderboardOptions) {
        this.options = leaderboardOptions;

        var rankHeight = Math.max($(document).height() - 108, 800);

        $('#rank-main').css('height', rankHeight);

        google.load('visualization', '1', { packages: ['corechart'] });

        countryCode = IREP.options.user.locationId;
        storeChainId = IREP.options.user.storeChainId;
        geoCode = IREP.options.user.geoCode;
        cultureCode = IREP.options.user.cultureCode;

        map = IREP.leaderboard.map;
        badgesApi = IREP.leaderboard.badges;
        trainingQualityApi = IREP.leaderboard.trainingQuality;
        passingPercentageApi = IREP.leaderboard.passingPercentage;
        legendsApi = IREP.leaderboard.legends;

        storage = window.sessionStorage;
        categoryChanged = "1";

        IREP.leaderboard.map.init(this.options.mapData);

        setTimeout(callSelectRegion, 0);

        var mapObj = $('#world-map').vectorMap('get', 'mapObject');
        mapObj.setSelectedRegions(countryCode);
        leaderboard_template = Handlebars.compile($("#leaderboard-template").html());

        loadOtherContentUserControl($("#ddlCategory").val());
        //$("#ddlCategory").val("Badges.ajax");
        $("#ddlTimeFrame").val("1w");
        if ($("#lblAttribute").text() === "") {
            $("#lblAttribute").text("mycountry");
        } else {
            $("#lblAttribute").text("");
        }
        $("#lblAttribute").hide();
        $("#lblCurrentLeaderDefault").text("1").hide();//boolean to set if current leader is the default display or the alternate, used to decide which set of current leaders to show next
        $("#lblBadgeTranslation").hide();
        $("#lblTrainingQualityTranslation").hide();
        $("#lblPassingPercentageTranslation").hide();
        $("#lblLegendsTranslation").hide();
        getLeaderboardMain();

        $("#slider-animate a").click(animateSlider);

        $("#divOtherContent").on("click", ".toggleCurrentLeaders", function () {
            resetCurrentLeaderTimer();
            return false;
        });

        $("#ddlCategory").change(function () {
            mapObj.clearSelectedRegions();
            map.selectRegion(countryCode, false);
            resetCurrentLeaderTimer();
            categoryChanged = "1";
            getLeaderboardMain();
            loadOtherContentUserControl($("#ddlCategory").val());
        });
        //Dropdownlist Selectedchange event
        $("#ddlTimeFrame").change(function () {
            // Get Dropdownlist seleted item text
            //$("#lbltxt").text($("#ddlTimeFrame option:selected").text());
            // Get Dropdownlist selected item value
            getLeaderboardMain();
        });
        //All countries click event
        $("#aAllCountries").click(function () {
            $("#lblAttribute").text("allcountries");
            map.selectRegion(countryCode, true);
            mapObj.clearSelectedRegions();
            getLeaderboardMain();
            setAttributeFilter();
            return false;
        });
        //My country click event
        $("#aMyCountry").click(function () {
            $("#lblAttribute").text("mycountry");
            mapObj.clearSelectedRegions();
            map.selectRegion(countryCode, false);
            getLeaderboardMain();
            setAttributeFilter();
            return false;
        });
        //My company click event
        $("#aMyCompany").click(function () {
            $("#lblAttribute").text("mycompany");
            mapObj.clearSelectedRegions();
            map.selectRegion(countryCode, false);
            getLeaderboardMain();
            setAttributeFilter();
            return false;
        });
    };

    var callSelectRegion = function () {
        var to = setTimeout(animateSlider, 1000);
        map.selectRegion(countryCode, false);
    };

    var getLeaderboardMain = function () {
        switch ($("#lblAttribute").text()) {
            case "allcountries":
                getLeaderboardRankings('', '');
                getMyStats('', '');
                break;
            case "mycountry":
                getLeaderboardRankings(countryCode, '');
                getMyStats(countryCode, '');
                break;
            case "mycompany":
                getLeaderboardRankings(countryCode, storeChainId);
                getMyStats(countryCode, storeChainId);
                break;
            default:
                getLeaderboardRankings('', '');
                getMyStats('', '');
        }
    };

    var getLeaderboardRankings = function (countryCode, storeChainId) {
        block($("#divLeaderboard"));
        $('#leaderlist').empty();
        var functionToCall;
        switch ($("#ddlCategory").val()) {
            case "Badges.ajax":
                functionToCall = badgesApi.getLeaders;
                break;
            case "TrainingQuality.ajax":
                functionToCall = trainingQualityApi.getPerformanceFirstAttempt;
                break;
            case "PassingPercentage.ajax":
                functionToCall = passingPercentageApi.getTopUsers;
                break;
            case "Legends.ajax":
                functionToCall = legendsApi.getLongestActiveMembers;
                break;
        }
        var timeFrame = $("#ddlTimeFrame").val();

        functionToCall(timeFrame, countryCode, storeChainId)
            .done(function (data) {
                if (data !== null && data.leaders !== null && data.leaders.length !== 0) {
                    var html = leaderboard_template(data.leaders);
                    $("#leaderlist").html(html);
                } else {
                    noData($("#leaderlist"));
                }
                $("#divLeaderboard").unblock();
            });
    };

    var getMyStats = function (countryCode, storeChainId) {
        block($("#divMyRankAndScore"));
        $('#lblRank').text("");
        $('#lblScore').text("");
        var timeFrame = $("#ddlTimeFrame").val();

        IREP.callApi("/leaderboard/my-stats", "GET", { geoCode: geoCode, timeFrame: timeFrame, countryCode: countryCode, storeChainId: storeChainId, leaderBoard: $("#ddlCategory").val() }, function (data) {
            if (data !== null && data.stats !== null) {
                $("#lblRank").html(data.stats.rank);
                $("#lblScore").html(data.stats.score);
            } else {
                $("#lblRank").text("");
                $("#lblScore").text("");
            }
            ($("#divMyRankAndScore")).unblock();
        });
    };

    var loadOtherContentUserControl = function (controlName) {
        var divOtherContent = $('#divOtherContent');
        divOtherContent.empty();
        $("#divOtherContent").load("leaderboard/" + controlName, function (response, status, xhr) {
            if (status != "error") {
                populateOtherContentData(controlName);

                resetCurrentLeaderTimer();
            }
        });
    };

    var populateOtherContentData = function (controlName) {
        $("#lblCurrentLeaderDefault").text("1"); //set back to default
        switch (controlName) {
            case "Badges.ajax":
                badgesApi.populateContent();
                break;
            case "TrainingQuality.ajax":
                trainingQualityApi.populateContent();
                break;
            case "PassingPercentage.ajax":
                passingPercentageApi.populateContent();
                break;
            case "Legends.ajax":
                legendsApi.populateContent();
                break;
        }
    };

    var block = function (div) {
        $.blockUI.defaults.css = {
            backgroundColor: 'none'
        };
        $.blockUI.defaults.overlayCSS = {
            backgroundColor: 'none'
        };

        var loaderGif = IREP.options.appUrl + "content/images/leaderboard/loader.gif";
        div.block({
            message: '<img src="' + loaderGif + '" alt="" />',
            bindEvents: false,
            css: {
                border: '0px none',
                background: 'none'
                //cursor: 'wait'
            }
        });
    };

    var noData = function (element) {
        element.empty();
        element.append("<span style='padding-left:80px; color:white;'></span>");
    };

    var setData = function (data, element) {
        if (data !== null) {
            element.html(data);
        } else {
            noData(element);
        }
    };

    var setAttributeFilter = function () {
        switch ($("#lblAttribute").text()) {
            case "allcountries":
                $("#divAllCountries").addClass("isselected");
                $("#divMyCountry").removeClass("isselected");
                $("#divMyCompany").removeClass("isselected");
                break;
            case "mycountry":
                $("#divAllCountries").removeClass("isselected");
                $("#divMyCountry").addClass("isselected");
                $("#divMyCompany").removeClass("isselected");
                break;
            case "mycompany":
                $("#divAllCountries").removeClass("isselected");
                $("#divMyCountry").removeClass("isselected");
                $("#divMyCompany").addClass("isselected");
                break;
        }
    };

    var getCurrentLeaders = function () {
        var score;
        var name;
        var country;
        var leaderboardName;
        var functionNameToCallColumn1;
        var functionNameToCallColumn2;
        var currentLeaderDefault;
        currentLeaderDefault = $("#lblCurrentLeaderDefault");
        var category;
        category = $("#ddlCategory").val();

        switch (category) {
            case "Badges.ajax":
                if (currentLeaderDefault.text() === "1") {
                    functionNameToCallColumn1 = "badges";
                    functionNameToCallColumn2 = "training-quality";
                } else {
                    functionNameToCallColumn1 = "passing-percentage";
                    functionNameToCallColumn2 = "legends";
                }
                break;
            case "TrainingQuality.ajax":
                if (currentLeaderDefault.text() === "1") {
                    functionNameToCallColumn1 = "training-quality";
                    functionNameToCallColumn2 = "passing-percentage";
                } else {
                    functionNameToCallColumn1 = "badges";
                    functionNameToCallColumn2 = "legends";
                }
                break;
            case "PassingPercentage.ajax":
                if (currentLeaderDefault.text() === "1") {
                    functionNameToCallColumn1 = "passing-percentage";
                    functionNameToCallColumn2 = "legends";
                } else {
                    functionNameToCallColumn1 = "badges";
                    functionNameToCallColumn2 = "training-quality";
                }
                break;
            case "Legends.ajax":
                if (currentLeaderDefault.text() === "1") {
                    functionNameToCallColumn1 = "legends";
                    functionNameToCallColumn2 = "badges";
                } else {
                    functionNameToCallColumn1 = "training-quality";
                    functionNameToCallColumn2 = "passing-percentage";
                }
                break;
        }

        if (currentLeaderDefault.text() === "1") {
            currentLeaderDefault.text("0");
        } else {
            currentLeaderDefault.text("1");
        }

        score = $("#lblLeaderScoreColumn1");
        name = $("#lblLeaderNameColumn1");
        country = $("#lblLeaderCountryFirstColumn");
        getLeader(1, functionNameToCallColumn1, score, name, country, $("#lblCategoryNameColumn1"));

        score = $("#lblLeaderScoreColumn2");
        name = $("#lblLeaderNameColumn2");
        country = $("#lblLeaderCountryColumn2");
        getLeader(2, functionNameToCallColumn2, score, name, country, $("#lblCategoryNameColumn2"));
        categoryChanged = "0";
    };

    var setCategoryName = function (categoryTranslation, functionNameToCall) {
        switch (functionNameToCall) {
            case "badges":
                categoryTranslation.text($("#lblBadgeTranslation").text());
                break;
            case "training-quality":
                categoryTranslation.text($("#lblTrainingQualityTranslation").text());
                break;
            case "passing-percentage":
                categoryTranslation.text($("#lblPassingPercentageTranslation").text());
                break;
            case "legends":
                categoryTranslation.text($("#lblLegendsTranslation").text());
                break;
        }
    };

    var getLeader = function (column, functionName, score, name, country, categoryName) {
        var session = sessionStorage.getItem(functionName + "_" + IREP.options.user.geoCode);
        if (session == null) { //if leader data not cached in sessionServer then make web call to get it
            if (categoryChanged === "1") {
                if (column === 1) {
                    block($("#divCurrentLeadersColumn1"));
                } else {
                    block($("#divCurrentLeadersColumn2"));
                }
            }
            if (!isPending(functionName)) {
                togglePending(functionName, true);
                IREP.callApi("leaderboard/" + functionName + "/leader", "GET").done(function (data) {
                    if (data !== null && data.leader !== null) {
                        setCategoryName(categoryName, functionName);
                        score.text(Math.round(data.leader.total));
                        name.text(data.leader.name);
                        country.text(data.leader.country);

                        if (column === 1) {
                            $("#divCurrentLeadersColumn1").unblock();
                        } else {
                            $("#divCurrentLeadersColumn2").unblock();
                        }
                        saveCurrentLeaderToSessionStorage(functionName, data.leader.total, data.leader.name, data.leader.country);
                        togglePending(functionName, false);
                    }
                });
            }
        } else { //get from sessionStorage
            if (categoryChanged === "0") {
                if (column === 1) {
                    $("#divCurrentLeadersColumn1").hide();
                } else {
                    $("#divCurrentLeadersColumn2").hide();
                }
            }
            var currentLeader = {};
            currentLeader = JSON.parse(session);
            setCategoryName(categoryName, functionName);
            score.text(Math.round(currentLeader.total));
            name.text(currentLeader.name);
            country.text(currentLeader.country);
            if (categoryChanged === "0") {
                if (column === 1) {
                    $("#divCurrentLeadersColumn1").fadeIn(4000);
                } else {
                    $("#divCurrentLeadersColumn2").fadeIn(4000);
                }
            }
        }
    };

    var togglePending = function (section, pending) {
        if (section === "badges") {
            badgesPending = pending;
        } else if (section === "training-quality") {
            trainingQualityPending = pending;
        } else if (section === "passing-percentage") {
            passingPercentagePending = pending;
        } else if (section === "legends") {
            legendsPending = pending;
        }
    };

    var isPending = function (section) {
        var pending = false;
        if (section === "badges") {
            pending = badgesPending;
        } else if (section === "training-quality") {
            pending = trainingQualityPending;
        } else if (section === "passing-percentage") {
            pending = passingPercentagePending;
        } else if (section === "legends") {
            pending = legendsPending;
        }
        return pending;
    };

    var saveCurrentLeaderToSessionStorage = function (category, total, name, country) {
        var currentLeader = {};
        currentLeader.category = category;
        currentLeader.total = total;
        currentLeader.name = name;
        currentLeader.country = country;
        sessionStorage.setItem(category + "_" + IREP.options.user.geoCode, JSON.stringify(currentLeader));
    };

    var ticker = function () {
        getCurrentLeaders();
    };

    var resetCurrentLeaderTimer = function () {
        clearTimeout(currentLeaderTimer);
        ticker();
        currentLeaderTimer = setTimeout(resetCurrentLeaderTimer, 6000);
    };

    var SliderOut = 0;
    var animateSlider = function () {
        if (SliderOut === 1) {
            $('#slider').animate({ width: '72px' }, 500);
            $('#imgExpand').show();
            SliderOut = 0;
        } else {
            $('#slider').animate({ width: '840px' }, 500);
            $('#imgExpand').hide();
            SliderOut = 1;
        }
    };

    var showLoader = function (show) {
        if (show === 1) {
            $("#imgLoader").fadeTo(0, 1);
            $("#badgeInfo").fadeTo(200, 0);
        } else {
            $("#imgLoader").fadeTo(800, 0);
            $("#badgeInfo").fadeTo(500, 1);
        }
    };

    return {
        init: init,
        block: block,
        noData: noData,
        setData: setData,
        getLeaderboardRankings: getLeaderboardRankings,
        getMyStats: getMyStats,
        setAttributeFilter: setAttributeFilter
    };
})();

IREP.leaderboard.map = (function () {
    var leaderboard = IREP.leaderboard;

    var init = function (mapOptions) {
        initMap(mapOptions);
    };

    var initMap = function (data) {
        var mapSettings = {
            global: {
                height: 440.7063107441331,
                width: 900,
                centralMeridian: 11.5,
                bbox: [
                    {
                        y: -12671671.123330014,
                        x: -20004297.151525836
                    },
                    {
                        y: 6930392.02513512,
                        x: 20026572.394749384
                    }
                ]
            },
            prc: {
                height: 603.7372052457338,
                width: 900,
                centralMeridian: 0,
                bbox: [
                    {
                        y: -6615931.205969351,
                        x: 8197509.958779432
                    },
                    {
                        y: -2045697.9239836007,
                        x: 15010424.448806616
                    }
                ]
            },
            asmo: {
                height: 583.0648778468864,
                width: 900,
                centralMeridian: 0,
                bbox: [
                 	{
                 	    y: -12522796.066032525,
                 	    x: -19771895.08914503
                 	},
					{
					    y: -2788573.3575807572,
					    x: -4746465.209097977
					}

                ]
            }
        };

        var geoMapSettings;

        if (IREP.options.user.geoCode === 'PRC') {
            geoMapSettings = mapSettings.prc;
        } else if (IREP.options.user.geoCode === 'ASMO') {
            geoMapSettings = mapSettings.asmo;
        } else {
            geoMapSettings = mapSettings.global;
        }

        $.fn.vectorMap('addMap', 'world_mill_en', {
            height: geoMapSettings.height,
            projection: {
                type: "mill",
                centralMeridian: geoMapSettings.centralMeridian
            },
            width: geoMapSettings.width,
            insets: [
                {
                    width: $(window).width(),
                    top: 0,
                    height: geoMapSettings.height,
                    bbox: geoMapSettings.bbox,
                    left: 0
                }
            ],
            paths: data.paths
        }
        );
        var markers = jQuery.map(data.markers, function (m) { return { latLng: [m.latitude, m.longitude], name: m.name }; });

        $("#world-map").vectorMap({
            backgroundColor: "#eeeeee",
            normalizeFunction: 'polynomial',
            zoomOnScroll: false,
            zoomStep: 2.0,
            zoomMin: 1.6,
            zoomMax: 3.2,
            focusOn: { x: 0.42, y: 0.0, scale: 1.6 },
            regionsSelectable: true,
            regionsSelectableOne: true,
            regionStyle: {
                initial: { fill: "#bbbbbb", "fill-opacity": 1, stroke: 'none', "stroke-width": 0, "stroke-opacity": 1 },
                hover: { fill: "#bbbbbb", "fill-opacity": 1, stroke: 'none', "stroke-width": 0, "stroke-opacity": 1 },
                selected: { fill: "#003c71", "fill-opacity": 1, stroke: 'none', "stroke-width": 0, "stroke-opacity": 1 },
                selectedHover: { fill: "#003c71", "fill-opacity": 1, stroke: 'none', "stroke-width": 0, "stroke-opacity": 1 }
            },
            selectedRegions: "",
            onRegionClick: function (e, c) {
                selectRegion(c, false);
                if ($("#lblAttribute").text() !== "mycountry") {
                    $("#lblAttribute").text("mycountry");
                }
                leaderboard.getLeaderboardRankings(c, '');
                leaderboard.getMyStats(c, '');
                leaderboard.setAttributeFilter();
            },
            onMarkerClick: function (e, c) {
            },
            markersSelectable: false,
            markersSelectableOne: true,
            markerStyle: {
                initial: { fill: '#666666', "fill-opacity": 1, stroke: '#cccccc', "stroke-width": 4, "stroke-opacity": 1, r: 3 },
                hover: { fill: '#666666', "fill-opacity": 1, stroke: '#cccccc', "stroke-width": 4, "stroke-opacity": 1 },
                selected: { fill: '#666666', "fill-opacity": 1, stroke: '#cccccc', "stroke-width": 4, "stroke-opacity": 1 },
                selectedHover: { fill: '#666666', "fill-opacity": 1, stroke: '#cccccc', "stroke-width": 4, "stroke-opacity": 1 }
            }
            //markers: markers
        });
    };

    var selectRegion = function (c, zout) {
        var mapObj = $('#world-map').vectorMap('get', 'mapObject');
        var zval = 4.4;
        var geoCode = IREP.options.user.geoCode;
        mapObj.setSelectedRegions(c);
        mapObj.setFocusLatLng = function (scale, lat, lng) {
            var point,
                proj = jvm.WorldMap.maps[this.params.map].projection,
                centralMeridian = proj.centralMeridian,
                width = this.width - this.baseTransX * 2 * this.baseScale,
                height = this.height - this.baseTransY * 2 * this.baseScale,
                inset,
                bbox,
                scaleFactor = this.scale / this.baseScale,
                centerX,
                centerY;

            if (lng < (-180 + centralMeridian)) {
                lng += 360;
            }

            point = jvm.Proj[proj.type](lat, lng, centralMeridian);
            inset = this.getInsetForPoint(point.x, point.y);

            if (inset) {
                bbox = inset.bbox;
                centerX = (point.x - bbox[0].x) / (bbox[1].x - bbox[0].x);
                centerY = (point.y - bbox[0].y) / (bbox[1].y - bbox[0].y);
                this.setFocus(scale, centerX, centerY);
            }

        };

        if (zout) {
            zval = 1.6;
        } else {
            zval = 4.4;
        }

        if (geoCode === 'EMEA') {
            switch (c) {
                // EMEA
                case "AD":
                    mapObj.setFocusLatLng(zval, 42.507790, 1.521090);
                    break;
                case "AE":
                    mapObj.setFocusLatLng(zval, 24.466670, 54.366670);
                    break;
                case "AL":
                    mapObj.setFocusLatLng(zval, 41.327500, 19.818890);
                    break;
                case "AM":
                    mapObj.setFocusLatLng(zval, 40.181110, 44.513610);
                    break;
                case "AO":
                    mapObj.setFocusLatLng(zval, -8.836820, 13.234320);
                    break;
                case "AT":
                    mapObj.setFocusLatLng(zval, 48.208490, 16.372080);
                    break;
                case "AZ":
                    mapObj.setFocusLatLng(zval, 40.377670, 49.892010);
                    break;
                case "BA":
                    mapObj.setFocusLatLng(zval, 43.848640, 18.356440);
                    break;
                case "BE":
                    mapObj.setFocusLatLng(zval, 50.850450, 4.348780);
                    break;
                case "BF":
                    mapObj.setFocusLatLng(zval, 12.365660, -1.533880);
                    break;
                case "BG":
                    mapObj.setFocusLatLng(zval, 42.697510, 23.324150);
                    break;
                case "BH":
                    mapObj.setFocusLatLng(zval, 26.215360, 50.583200);
                    break;
                case "BI":
                    mapObj.setFocusLatLng(zval, -3.382200, 29.364400);
                    break;
                case "BJ":
                    mapObj.setFocusLatLng(zval, 6.496460, 2.603590);
                    break;
                case "BW":
                    mapObj.setFocusLatLng(zval, -24.654510, 25.908590);
                    break;
                case "BY":
                    mapObj.setFocusLatLng(zval, 53.900000, 27.566670);
                    break;
                case "CD":
                    mapObj.setFocusLatLng(zval, -4.321420, 15.308070);
                    break;
                case "CF":
                    mapObj.setFocusLatLng(zval, 4.361220, 18.554960);
                    break;
                case "CG":
                    mapObj.setFocusLatLng(zval, -4.266130, 15.283180);
                    break;
                case "CH":
                    mapObj.setFocusLatLng(zval, 46.948090, 7.447440);
                    break;
                case "CI":
                    mapObj.setFocusLatLng(zval, 6.820550, -5.276740);
                    break;
                case "CM":
                    mapObj.setFocusLatLng(zval, 3.866670, 11.516670);
                    break;
                case "CV":
                    mapObj.setFocusLatLng(zval, 14.931520, -23.512540);
                    break;
                case "CY":
                    mapObj.setFocusLatLng(zval, 35.166670, 33.366670);
                    break;
                case "CZ":
                    mapObj.setFocusLatLng(zval, 50.088040, 14.420760);
                    break;
                case "DE":
                    mapObj.setFocusLatLng(zval, 52.524370, 13.410530);
                    break;
                case "DJ":
                    mapObj.setFocusLatLng(zval, 11.589010, 43.145030);
                    break;
                case "DK":
                    mapObj.setFocusLatLng(zval, 55.675940, 12.565530);
                    break;
                case "DZ":
                    mapObj.setFocusLatLng(zval, 36.752500, 3.041970);
                    break;
                case "EE":
                    mapObj.setFocusLatLng(zval, 59.436960, 24.753530);
                    break;
                case "EG":
                    mapObj.setFocusLatLng(zval, 30.062630, 31.249670);
                    break;
                case "EH":
                    mapObj.setFocusLatLng(zval, 27.162240, -13.203150);
                    break;
                case "ER":
                    mapObj.setFocusLatLng(zval, 15.338050, 38.931840);
                    break;
                case "ES":
                    mapObj.setFocusLatLng(zval, 40.416500, -3.702560);
                    break;
                case "ET":
                    mapObj.setFocusLatLng(zval, 9.024970, 38.746890);
                    break;
                case "FI":
                    mapObj.setFocusLatLng(zval, 60.169520, 24.935450);
                    break;
                case "FO":
                    mapObj.setFocusLatLng(zval, 62.009730, -6.771640);
                    break;
                case "FR":
                    mapObj.setFocusLatLng(zval, 48.853410, 2.348800);
                    break;
                case "GA":
                    mapObj.setFocusLatLng(zval, 0.392410, 9.453560);
                    break;
                case "GB":
                    mapObj.setFocusLatLng(zval, 51.508530, -0.125740);
                    break;
                case "GE":
                    mapObj.setFocusLatLng(zval, 41.694110, 44.833680);
                    break;
                case "GH":
                    mapObj.setFocusLatLng(zval, 5.556020, -0.196900);
                    break;
                case "GI":
                    mapObj.setFocusLatLng(zval, 36.144740, -5.352570);
                    break;
                case "GL":
                    mapObj.setFocusLatLng(zval, 64.183470, -51.721570);
                    break;
                case "GM":
                    mapObj.setFocusLatLng(zval, 13.452740, -16.578030);
                    break;
                case "GN":
                    mapObj.setFocusLatLng(zval, 9.537950, -13.677290);
                    break;
                case "GQ":
                    mapObj.setFocusLatLng(zval, 3.750000, 8.783330);
                    break;
                case "GR":
                    mapObj.setFocusLatLng(zval, 37.979450, 23.716220);
                    break;
                case "GW":
                    mapObj.setFocusLatLng(zval, 11.863570, -15.597670);
                    break;
                case "HR":
                    mapObj.setFocusLatLng(zval, 45.814440, 15.977980);
                    break;
                case "HU":
                    mapObj.setFocusLatLng(zval, 47.498010, 19.039910);
                    break;
                case "IE":
                    mapObj.setFocusLatLng(zval, 53.333060, -6.248890);
                    break;
                case "IQ":
                    mapObj.setFocusLatLng(zval, 33.340580, 44.400880);
                    break;
                case "IS":
                    mapObj.setFocusLatLng(zval, 64.135480, -21.895410);
                    break;
                case "IT":
                    mapObj.setFocusLatLng(zval, 41.894740, 12.483900);
                    break;
                case "JO":
                    mapObj.setFocusLatLng(zval, 31.955220, 35.945030);
                    break;
                case "KE":
                    mapObj.setFocusLatLng(zval, -1.283330, 36.816670);
                    break;
                case "KG":
                    mapObj.setFocusLatLng(zval, 42.870000, 74.590000);
                    break;
                case "KM":
                    mapObj.setFocusLatLng(zval, -11.702160, 43.255060);
                    break;
                case "KW":
                    mapObj.setFocusLatLng(zval, 29.369720, 47.978330);
                    break;
                case "KZ":
                    mapObj.setFocusLatLng(zval, 51.180100, 71.445980);
                    break;
                case "LB":
                    mapObj.setFocusLatLng(zval, 33.888940, 35.494420);
                    break;
                case "LI":
                    mapObj.setFocusLatLng(zval, 47.141510, 9.521540);
                    break;
                case "LR":
                    mapObj.setFocusLatLng(zval, 6.300540, -10.796900);
                    break;
                case "LS":
                    mapObj.setFocusLatLng(zval, -29.316670, 27.483330);
                    break;
                case "LT":
                    mapObj.setFocusLatLng(zval, 54.689160, 25.279800);
                    break;
                case "LU":
                    mapObj.setFocusLatLng(zval, 49.611670, 6.130000);
                    break;
                case "LV":
                    mapObj.setFocusLatLng(zval, 56.946000, 24.105890);
                    break;
                case "MA":
                    mapObj.setFocusLatLng(zval, 34.013250, -6.832550);
                    break;
                case "MC":
                    mapObj.setFocusLatLng(zval, 43.733330, 7.416670);
                    break;
                case "MD":
                    mapObj.setFocusLatLng(zval, 47.005560, 28.857500);
                    break;
                case "ME":
                    mapObj.setFocusLatLng(zval, 42.441110, 19.263610);
                    break;
                case "MG":
                    mapObj.setFocusLatLng(zval, -18.913680, 47.536130);
                    break;
                case "MK":
                    mapObj.setFocusLatLng(zval, 42.001220, 21.428780);
                    break;
                case "ML":
                    mapObj.setFocusLatLng(zval, 12.650000, -8.000000);
                    break;
                case "MR":
                    mapObj.setFocusLatLng(zval, 18.085810, -15.978500);
                    break;
                case "MT":
                    mapObj.setFocusLatLng(zval, 35.899720, 14.514720);
                    break;
                case "MU":
                    mapObj.setFocusLatLng(zval, -20.161940, 57.498890);
                    break;
                case "MW":
                    mapObj.setFocusLatLng(zval, -13.966920, 33.787250);
                    break;
                case "MZ":
                    mapObj.setFocusLatLng(zval, -25.965530, 32.583220);
                    break;
                case "NA":
                    mapObj.setFocusLatLng(zval, -22.559410, 17.083230);
                    break;
                case "NE":
                    mapObj.setFocusLatLng(zval, 13.513660, 2.109800);
                    break;
                case "NG":
                    mapObj.setFocusLatLng(zval, 9.068530, 7.483750);
                    break;
                case "NL":
                    mapObj.setFocusLatLng(zval, 52.374030, 4.889690);
                    break;
                case "NO":
                    mapObj.setFocusLatLng(zval, 59.912730, 10.746090);
                    break;
                case "OM":
                    mapObj.setFocusLatLng(zval, 23.613870, 58.592200);
                    break;
                case "PL":
                    mapObj.setFocusLatLng(zval, 52.229770, 21.011780);
                    break;
                case "PM":
                    mapObj.setFocusLatLng(zval, 46.780910, -56.171960);
                    break;
                case "PT":
                    mapObj.setFocusLatLng(zval, 38.716670, -9.133330);
                    break;
                case "QA":
                    mapObj.setFocusLatLng(zval, 25.279320, 51.522450);
                    break;
                case "RE":
                    mapObj.setFocusLatLng(zval, -20.882310, 55.450400);
                    break;
                case "RO":
                    mapObj.setFocusLatLng(zval, 44.432250, 26.106260);
                    break;
                case "RS":
                    mapObj.setFocusLatLng(zval, 44.804010, 20.465130);
                    break;
                case "RU":
                    mapObj.setFocusLatLng(zval, 55.752220, 37.615560);
                    break;
                case "RW":
                    mapObj.setFocusLatLng(zval, -1.949950, 30.058850);
                    break;
                case "SA":
                    mapObj.setFocusLatLng(zval, 24.687730, 46.721850);
                    break;
                case "SC":
                    mapObj.setFocusLatLng(zval, -4.616670, 55.450000);
                    break;
                case "SE":
                    mapObj.setFocusLatLng(zval, 59.332580, 18.064900);
                    break;
                case "SH":
                    mapObj.setFocusLatLng(zval, -15.938720, -5.716750);
                    break;
                case "SI":
                    mapObj.setFocusLatLng(zval, 46.051080, 14.505130);
                    break;
                case "SJ":
                    mapObj.setFocusLatLng(zval, 78.218600, 15.640070);
                    break;
                case "SK":
                    mapObj.setFocusLatLng(zval, 48.148160, 17.106740);
                    break;
                case "SL":
                    mapObj.setFocusLatLng(zval, 8.484000, -13.229940);
                    break;
                case "SM":
                    mapObj.setFocusLatLng(zval, 43.936670, 12.446390);
                    break;
                case "SN":
                    mapObj.setFocusLatLng(zval, 14.693700, -17.444060);
                    break;
                case "SO":
                    mapObj.setFocusLatLng(zval, 2.037110, 45.343750);
                    break;
                case "ST":
                    mapObj.setFocusLatLng(zval, 0.336540, 6.727320);
                    break;
                case "SZ":
                    mapObj.setFocusLatLng(zval, -26.316670, 31.133330);
                    break;
                case "TD":
                    mapObj.setFocusLatLng(zval, 12.106720, 15.044400);
                    break;
                case "TF":
                    mapObj.setFocusLatLng(zval, -49.350000, 70.216670);
                    break;
                case "TG":
                    mapObj.setFocusLatLng(zval, 6.137480, 1.212270);
                    break;
                case "TJ":
                    mapObj.setFocusLatLng(zval, 38.535750, 68.779050);
                    break;
                case "TM":
                    mapObj.setFocusLatLng(zval, 37.950000, 58.383330);
                    break;
                case "TN":
                    mapObj.setFocusLatLng(zval, 36.818970, 10.165790);
                    break;
                case "TR":
                    mapObj.setFocusLatLng(zval, 39.919870, 32.854270);
                    break;
                case "TZ":
                    mapObj.setFocusLatLng(zval, -6.172210, 35.739470);
                    break;
                case "UA":
                    mapObj.setFocusLatLng(zval, 50.454660, 30.523800);
                    break;
                case "UG":
                    mapObj.setFocusLatLng(zval, 0.316280, 32.582190);
                    break;
                case "UZ":
                    mapObj.setFocusLatLng(zval, 41.264650, 69.216270);
                    break;
                case "VA":
                    mapObj.setFocusLatLng(zval, 41.902360, 12.453320);
                    break;
                case "YE":
                    mapObj.setFocusLatLng(zval, 15.354720, 44.206670);
                    break;
                case "YT":
                    mapObj.setFocusLatLng(zval, -12.779440, 45.227220);
                    break;
                case "ZA":
                    mapObj.setFocusLatLng(zval, -25.744860, 28.187830);
                    break;
                case "ZM":
                    mapObj.setFocusLatLng(zval, -15.406690, 28.287130);
                    break;
                case "ZW":
                    mapObj.setFocusLatLng(zval, -17.827720, 31.053370);
                    break;
                default:
                    break;
            }
        } else if (geoCode === 'APAC') {
            // APAC
            switch (c) {
                case "AU":
                    mapObj.setFocusLatLng(zval, -35.283460, 149.128070);
                    break;
                case "BD":
                    mapObj.setFocusLatLng(zval, 23.710400, 90.407440);
                    break;
                case "ID":
                    mapObj.setFocusLatLng(zval, -6.214620, 106.845130);
                    break;
                case "IN":
                    mapObj.setFocusLatLng(zval, 28.635760, 77.224450);
                    break;
                case "KR":
                    mapObj.setFocusLatLng(zval, 37.568260, 126.977830);
                    break;
                case "LK":
                    mapObj.setFocusLatLng(zval, 6.931940, 79.847780);
                    break;
                case "MN":
                    mapObj.setFocusLatLng(zval, 47.907710, 106.883240);
                    break;
                case "MY":
                    mapObj.setFocusLatLng(zval, 3.141200, 101.686530);
                    break;
                case "NZ":
                    mapObj.setFocusLatLng(zval, -41.286640, 174.775570);
                    break;
                case "PH":
                    mapObj.setFocusLatLng(zval, 14.604200, 120.982200);
                    break;
                case "PK":
                    mapObj.setFocusLatLng(zval, 33.721480, 73.043290);
                    break;
                case "SG":
                    mapObj.setFocusLatLng(zval, 1.289670, 103.850070);
                    break;
                case "TH":
                    mapObj.setFocusLatLng(zval, 13.753980, 100.501440);
                    break;
                case "TW":
                    mapObj.setFocusLatLng(zval, 25.047760, 121.531850);
                    break;
                case "VN":
                    mapObj.setFocusLatLng(zval, 21.024500, 105.841170);
                    break;
                default:
                    break;
            }
        } else if (geoCode === "LAR") {
            switch (c) {
                // LAR
                case "AR":
                    mapObj.setFocusLatLng(zval, -34.613150, -58.377230);
                    break;
                case "BR":
                    mapObj.setFocusLatLng(zval, -15.779720, -47.929720);
                    break;
                case "CL":
                    mapObj.setFocusLatLng(zval, -33.456940, -70.648270);
                    break;
                case "CO":
                    mapObj.setFocusLatLng(zval, 4.609710, -74.081750);
                    break;
                case "CR":
                    mapObj.setFocusLatLng(zval, 9.933330, -84.083330);
                    break;
                case "DO":
                    mapObj.setFocusLatLng(zval, 18.500120, -69.988570);
                    break;
                case "EC":
                    mapObj.setFocusLatLng(zval, -0.229850, -78.524950);
                    break;
                case "GT":
                    mapObj.setFocusLatLng(zval, 14.640720, -90.513270);
                    break;
                case "MX":
                    mapObj.setFocusLatLng(zval, 19.428470, -99.127660);
                    break;
                case "NI":
                    mapObj.setFocusLatLng(zval, 12.132820, -86.250400);
                    break;
                case "PA":
                    mapObj.setFocusLatLng(zval, 8.993600, -79.519730);
                    break;
                case "PE":
                    mapObj.setFocusLatLng(zval, -12.043180, -77.028240);
                    break;
                case "SV":
                    mapObj.setFocusLatLng(zval, 13.689350, -89.187180);
                    break;
                case "UY":
                    mapObj.setFocusLatLng(zval, -34.833460, -56.167350);
                    break;
                case "VE":
                    mapObj.setFocusLatLng(zval, 10.488010, -66.879190);
                    break;
                default:
                    break;
            }
        } else if (geoCode === 'PRC') {
            switch (c) {
                //PRC
                case "CN-54":
                    mapObj.setFocusLatLng(zval, 29.650000, 91.100000);
                    break;
                case "CN-52":
                    mapObj.setFocusLatLng(zval, 26.583330, 106.716670);
                    break;
                case "CN-35":
                    mapObj.setFocusLatLng(zval, 26.061390, 119.306110);
                    break;
                case "CN-50":
                    mapObj.setFocusLatLng(zval, 29.562780, 106.552780);
                    break;
                case "CN-51":
                    mapObj.setFocusLatLng(zval, 30.666670, 104.066670);
                    break;
                case "CN-31":
                    mapObj.setFocusLatLng(zval, 31.222220, 121.458060);
                    break;
                case "CN-32":
                    mapObj.setFocusLatLng(zval, 32.061670, 118.777780);
                    break;
                case "CN-33":
                    mapObj.setFocusLatLng(zval, 30.293650, 120.161420);
                    break;
                case "CN-14":
                    mapObj.setFocusLatLng(zval, 37.869440, 112.560280);
                    break;
                case "CN-15":
                    mapObj.setFocusLatLng(zval, 40.810560, 111.652220);
                    break;
                case "CN-12":
                    mapObj.setFocusLatLng(zval, 39.142220, 117.176670);
                    break;
                case "CN-13":
                    mapObj.setFocusLatLng(zval, 38.041390, 114.478610);
                    break;
                case "CN-11":
                    mapObj.setFocusLatLng(zval, 39.907500, 116.397230);
                    break;
                case "CN-34":
                    mapObj.setFocusLatLng(zval, 31.863890, 117.280830);
                    break;
                case "CN-53":
                    mapObj.setFocusLatLng(zval, 25.038890, 102.718330);
                    break;
                case "CN-36":
                    mapObj.setFocusLatLng(zval, 28.683330, 115.883330);
                    break;
                case "CN-37":
                    mapObj.setFocusLatLng(zval, 36.668330, 116.997220);
                    break;
                case "CN-41":
                    mapObj.setFocusLatLng(zval, 34.757780, 113.648610);
                    break;
                case "CN-43":
                    mapObj.setFocusLatLng(zval, 28.198740, 112.970870);
                    break;
                case "CN-42":
                    mapObj.setFocusLatLng(zval, 30.583330, 114.266670);
                    break;
                case "CN-45":
                    mapObj.setFocusLatLng(zval, 22.816670, 108.316670);
                    break;
                case "CN-44":
                    mapObj.setFocusLatLng(zval, 23.116670, 113.250000);
                    break;
                case "CN-46":
                    mapObj.setFocusLatLng(zval, 20.045830, 110.341670);
                    break;
                case "CN-65":
                    mapObj.setFocusLatLng(zval, 43.800960, 87.600460);
                    break;
                case "CN-64":
                    mapObj.setFocusLatLng(zval, 38.468060, 106.273060);
                    break;
                case "CN-63":
                    mapObj.setFocusLatLng(zval, 36.616670, 101.766670);
                    break;
                case "CN-62":
                    mapObj.setFocusLatLng(zval, 36.056390, 103.792220);
                    break;
                case "CN-61":
                    mapObj.setFocusLatLng(zval, 34.258330, 108.928610);
                    break;
                case "CN-23":
                    mapObj.setFocusLatLng(zval, 45.750000, 126.650000);
                    break;
                case "CN-22":
                    mapObj.setFocusLatLng(zval, 43.880000, 125.322780);
                    break;
                case "CN-21":
                    mapObj.setFocusLatLng(zval, 41.792220, 123.432780);
                    break;
                default:
                    break;
            }
        } else if (geoCode === 'ASMO') {
            //ASMO
            switch (c) {
                case "NY":
                    mapObj.setFocusLatLng(zval, 42.652580, -73.756230);
                    break;
                case "MD":
                    mapObj.setFocusLatLng(zval, 38.978450, -76.492180);
                    break;
                case "GA":
                    mapObj.setFocusLatLng(zval, 33.749000, -84.387980);
                    break;
                case "ME":
                    mapObj.setFocusLatLng(zval, 44.310620, -69.779490);
                    break;
                case "TX":
                    mapObj.setFocusLatLng(zval, 30.267150, -97.743060);
                    break;
                case "LA":
                    mapObj.setFocusLatLng(zval, 30.450750, -91.154550);
                    break;
                case "ND":
                    mapObj.setFocusLatLng(zval, 46.808330, -100.783740);
                    break;
                case "ID":
                    mapObj.setFocusLatLng(zval, 43.613500, -116.203450);
                    break;
                case "MA":
                    mapObj.setFocusLatLng(zval, 42.358430, -71.059770);
                    break;
                case "NV":
                    mapObj.setFocusLatLng(zval, 39.163800, -119.767400);
                    break;
                case "WV":
                    mapObj.setFocusLatLng(zval, 38.349820, -81.632620);
                    break;
                case "WY":
                    mapObj.setFocusLatLng(zval, 41.139980, -104.820250);
                    break;
                case "SC":
                    mapObj.setFocusLatLng(zval, 34.000710, -81.034810);
                    break;
                case "OH":
                    mapObj.setFocusLatLng(zval, 39.961180, -82.998790);
                    break;
                case "NH":
                    mapObj.setFocusLatLng(zval, 43.208140, -71.537570);
                    break;
                case "CO":
                    mapObj.setFocusLatLng(zval, 39.739150, -104.984700);
                    break;
                case "IA":
                    mapObj.setFocusLatLng(zval, 41.600540, -93.609110);
                    break;
                case "DE":
                    mapObj.setFocusLatLng(zval, 39.158170, -75.524370);
                    break;
                case "KY":
                    mapObj.setFocusLatLng(zval, 38.200910, -84.873280);
                    break;
                case "PA":
                    mapObj.setFocusLatLng(zval, 40.273700, -76.884420);
                    break;
                case "CT":
                    mapObj.setFocusLatLng(zval, 41.763710, -72.685090);
                    break;
                case "MT":
                    mapObj.setFocusLatLng(zval, 46.592710, -112.036110);
                    break;
                case "HI":
                    mapObj.setFocus("HI");
                    mapObj.setScale(zval);
                    //mapObj.setFocusLatLng(zval, 21.306940, -157.858330);
                    break;
                case "IN":
                    mapObj.setFocusLatLng(zval, 39.768380, -86.158040);
                    break;
                case "MS":
                    mapObj.setFocusLatLng(zval, 32.298760, -90.184810);
                    break;
                case "MO":
                    mapObj.setFocusLatLng(zval, 38.576700, -92.173520);
                    break;
                case "AK":
                    mapObj.setFocusLatLng(zval, 58.301940, -134.419720);
                    break;
                case "MI":
                    mapObj.setFocusLatLng(zval, 42.732540, -84.555530);
                    break;
                case "NE":
                    mapObj.setFocusLatLng(zval, 40.800000, -96.666960);
                    break;
                case "AR":
                    mapObj.setFocusLatLng(zval, 34.746480, -92.289590);
                    break;
                case "WI":
                    mapObj.setFocusLatLng(zval, 43.073050, -89.401230);
                    break;
                case "AL":
                    mapObj.setFocusLatLng(zval, 32.366810, -86.299970);
                    break;
                case "VT":
                    mapObj.setFocusLatLng(zval, 44.250000, -72.566700);
                    break;
                case "TN":
                    mapObj.setFocusLatLng(zval, 36.165890, -86.784440);
                    break;
                case "OK":
                    mapObj.setFocusLatLng(zval, 35.467560, -97.516430);
                    break;
                case "WA":
                    mapObj.setFocusLatLng(zval, 47.037870, -122.900700);
                    break;
                case "AZ":
                    mapObj.setFocusLatLng(zval, 33.448380, -112.074040);
                    break;
                case "SD":
                    mapObj.setFocusLatLng(zval, 44.367966, -100.336378);
                    break;
                case "RI":
                    mapObj.setFocusLatLng(zval, 41.823990, -71.412830);
                    break;
                case "NC":
                    mapObj.setFocusLatLng(zval, 35.772100, -78.638610);
                    break;
                case "VA":
                    mapObj.setFocusLatLng(zval, 37.553760, -77.460260);
                    break;
                case "CA":
                    mapObj.setFocusLatLng(zval, 38.581570, -121.494400);
                    break;
                case "MN":
                    mapObj.setFocusLatLng(zval, 44.944410, -93.093270);
                    break;
                case "OR":
                    mapObj.setFocusLatLng(zval, 44.942900, -123.035100);
                    break;
                case "UT":
                    mapObj.setFocusLatLng(zval, 40.760780, -111.891050);
                    break;
                case "NM":
                    mapObj.setFocusLatLng(zval, 35.686980, -105.937800);
                    break;
                case "IL":
                    mapObj.setFocusLatLng(zval, 39.801720, -89.643710);
                    break;
                case "FL":
                    mapObj.setFocusLatLng(zval, 30.438260, -84.280730);
                    break;
                case "KS":
                    mapObj.setFocusLatLng(zval, 39.048330, -95.678040);
                    break;
                case "NJ":
                    mapObj.setFocusLatLng(zval, 40.217050, -74.742940);
                    break;
                case "DC":
                    mapObj.setFocusLatLng(zval, 38.895110, -77.036370);
                    break;
                case "PE":
                    mapObj.setFocusLatLng(zval, 46.235250, -63.126710);
                    break;
                case "AB":
                    mapObj.setFocusLatLng(zval, 53.550140, -113.468710);
                    break;
                case "NB":
                    mapObj.setFocusLatLng(zval, 45.945410, -66.665580);
                    break;
                case "NS":
                    mapObj.setFocusLatLng(zval, 44.645330, -63.572390);
                    break;
                case "NU":
                    mapObj.setFocusLatLng(zval, 63.748611, -68.519722);
                    break;
                case "QC":
                    mapObj.setFocusLatLng(zval, 46.812280, -71.214540);
                    break;
                case "SK":
                    mapObj.setFocusLatLng(zval, 50.450080, -104.617800);
                    break;
                case "NL":
                    mapObj.setFocusLatLng(zval, 47.564940, -52.709310);
                    break;
                case "ON":
                    mapObj.setFocusLatLng(zval, 43.700110, -79.416300);
                    break;
                case "BC":
                    mapObj.setFocusLatLng(zval, 48.432940, -123.369300);
                    break;
                case "TY":
                    mapObj.setFocusLatLng(zval, 60.716110, -135.053750);
                    break;
                case "MB":
                    mapObj.setFocusLatLng(zval, 49.884400, -97.147040);
                    break;
                case "NT":
                    mapObj.setFocusLatLng(zval, 62.456000, -114.352550);
                    break;
                default:
                    break;
            }
        } else if (geoCode == "IJKK") {
            switch (c) {
                case "JP":
                    mapObj.setFocusLatLng(zval, 35.689500, 139.691710);
                    break;
                default:
                    break;
            }
        }
    };

    return {
        init: init,
        selectRegion: selectRegion
    };
})();

IREP.leaderboard.badges = (function () {
    var leaderboard = IREP.leaderboard;
    var myBadgesTemplate, mostPopularAndRarestTemplate;

    var getLeaders = function (timeFrame, countryCode, storeChainId) {
        return IREP.callApi("leaderboard/badges/users-with-most", "GET", { timeFrame: timeFrame, countryCode: countryCode, storeChainId: storeChainId });
    };

    var getLeader = function () {
        return IREP.callApi("leaderboard/badges/leader", "GET");
    };

    var getMine = function () {
        return IREP.callApi("leaderboard/badges/mine", "GET");
    };

    var getMostPopular = function () {
        return IREP.callApi("leaderboard/badges/most-popular", "GET");
    };

    var getRarest = function () {
        return IREP.callApi("leaderboard/badges/rarest", "GET");
    };

    var populateContent = function () {
        showMyBadges();
        showMostPoularAndRarestBadges();
    };

    var showMyBadges = function () {
        leaderboard.block($("#divMyBadges"));
        if (myBadgesTemplate == null) {
            myBadgesTemplate = Handlebars.compile($("#leaderboard-mybadges-template").html());
        }

        getMine().done(function (data) {
            if (data !== null && data.badges !== null && data.badges.length !== 0) {
                var html = myBadgesTemplate(data.badges);
                $("#MyBadges").html(html);
                $('#MyBadges').mCustomScrollbar({theme: 'dark-thick'});
            } else {
                $("#MyBadges").empty();
                leaderboard.noData($("#MyBadges"));
            }

            $("#lblBadgeCount").html(data.badges.length);
            $("#divMyBadges").unblock();
        });
    };

    var showMostPoularAndRarestBadges = function () {
        if (mostPopularAndRarestTemplate == null) {
            mostPopularAndRarestTemplate = Handlebars.compile($("#leaderboard-mostpopular-rarestbadges-template").html());
        }

        leaderboard.block($("#divPopularRare"));
        $.when(getMostPopular(), getRarest()).done(function (popular, rarest) {
            popular = popular[0];
            rarest = rarest[0];
            if (popular !== null && popular.badges !== null && popular.badges.length !== 0) {
                var html = mostPopularAndRarestTemplate(popular.badges);
                $("#divBadgesPopular").html(html);
            } else {
                $("#divBadgesPopular").empty();
                leaderboard.noData($("#divBadgesPopular"));
            }

            if (rarest !== null && rarest.badges !== null && rarest.badges.length !== 0) {
                var html = mostPopularAndRarestTemplate(rarest.badges);
                $("#divBadgesRarest").html(html);
                
            } else {
                leaderboard.noData($("#divBadgesRarest"));
            }

            $("#divPopularRare").unblock();

            $('#divPopularRare').mCustomScrollbar({
                theme: 'dark-thick'
            });
        }).always(function() {
            $("#divPopularRare").unblock();
        });
    };

    return {
        getLeaders: getLeaders,
        getLeader: getLeader,
        populateContent: populateContent
    };
})();

IREP.leaderboard.trainingQuality = (function () {
    var leaderboard = IREP.leaderboard;
    var toughestTrainingsTemplate;

    var getPerformanceFirstAttempt = function (timeFrame, countryCode, storeChainId) {
        return IREP.callApi("leaderboard/training-quality/performance-first-attempt", "GET", { timeFrame: timeFrame, countryCode: countryCode, storeChainId: storeChainId });
    };

    var getLeader = function () {
        return IREP.callApi("leaderboard/training-quality/leader", "GET");
    };

    var getAvailableTrainingsCount = function () {
        return IREP.callApi("leaderboard/training-quality/available-trainings-count", "GET");
    };

    var getAverageCorrectFirstAttempt = function () {
        return IREP.callApi("leaderboard/training-quality/average-correct-first-attempt", "GET");
    };

    var getToughestTrainings = function () {
        return IREP.callApi("leaderboard/training-quality/toughest-trainings", "GET");
    };

    var populateContent = function () {
        showAvailableTrainings();
        showAverageCorrectFirstAttempt();
        showToughestTrainings();
    };

    var showAvailableTrainings = function () {
        leaderboard.block($("#divAvailableTrainings"));

        getAvailableTrainingsCount().done(function (data) {
            leaderboard.setData(data.availableTrainingsCount, $("#lblAvailableTrainings"));
            $("#divAvailableTrainings").unblock();
        });
    };

    var showAverageCorrectFirstAttempt = function () {
        leaderboard.block($("#divAverageScore"));

        getAverageCorrectFirstAttempt().done(function (data) {
            leaderboard.setData(data.averageCorrectFirstAttempt, $("#lblAverageScore"));
            $("#divAverageScore").unblock();
        });
    };

    var showToughestTrainings = function () {
        leaderboard.block($("#divToughestTrainings"));
        if (toughestTrainingsTemplate == null) {
            toughestTrainingsTemplate = Handlebars.compile($("#leaderboard-toughesttrainings-template").html());
        }

        getToughestTrainings().done(function (data) {
            if (data !== null && data.trainings !== null && data.trainings.length !== 0) {
                var html = toughestTrainingsTemplate(data.trainings);
                $("#olToughestTrainings").html(html);
                $('#divToughestTrainings .contentPadding').mCustomScrollbar({
                    theme: 'dark-thick'
                });
            } else {
                leaderboard.noData($("#olToughestTrainings"));
            }

            $("#divToughestTrainings").unblock();
        });
    };

    return {
        getPerformanceFirstAttempt: getPerformanceFirstAttempt,
        getLeader: getLeader,
        populateContent: populateContent
    };
})();

IREP.leaderboard.passingPercentage = (function () {
    var leaderboard = IREP.leaderboard;

    var getTopUsers = function (timeFrame, countryCode, storeChainId) {
        return IREP.callApi("leaderboard/passing-percentage/top-users", "GET", { timeFrame: timeFrame, countryCode: countryCode, storeChainId: storeChainId });
    };

    var getLeader = function () {
        return IREP.callApi("leaderboard/passing-percentage/leader", "GET");
    };

    var lastYear = {
        getTrainingsTaken: function () {
            return IREP.callApi("leaderboard/passing-percentage/last-year/trainings-taken", "GET");
        },

        getPassingPercentage: function () {
            return IREP.callApi("leaderboard/passing-percentage/last-year/passing-percentage", "GET");
        },

        getMostPopularTraining: function () {
            return IREP.callApi("leaderboard/passing-percentage/last-year/most-popular-training", "GET");
        }
    };

    var getMyTrainingsPassed = function () {
        return IREP.callApi("leaderboard/passing-percentage/my-trainings-passed", "GET");
    };

    var getAverageTrainingsPassed = function () {
        return IREP.callApi("leaderboard/passing-percentage/average-trainings-passed", "GET");
    };

    var getMostTrainingsPassed = function () {
        return IREP.callApi("leaderboard/passing-percentage/most-trainings-passed", "GET");
    };

    var populateContent = function () {
        leaderboard.block($("#divOnThisDayLastYear"));
        showTrainingsTaken();
        showPassingPercentage();
        showMostPopularTraining();  // unblock happens here

        leaderboard.block($("#divTrainingsPassed"));
        showMyTrainingsPassed();
        showAverageTrainingsPassed();
        showMostTrainingsPassed(); // unblock happens here
    };

    var showTrainingsTaken = function () {
        lastYear.getTrainingsTaken().done(function (data) {
            leaderboard.setData(data.trainingsTaken, $("#lblTrainingsTaken"));
        });
    };
    var showPassingPercentage = function () {
        lastYear.getPassingPercentage().done(function (data) {
            leaderboard.setData(data.passingPercentage.toFixed(1), $("#lblPassingPercentage"));
        });
    };
    var showMostPopularTraining = function () {
        lastYear.getMostPopularTraining().done(function (data) {
            leaderboard.setData(data.training, $("#lblMostPopularTraining"));
            $("#divOnThisDayLastYear").unblock();
        });
    };
    var showMyTrainingsPassed = function () {
        getMyTrainingsPassed().done(function (data) {
            leaderboard.setData(data.passed, $("#lblMyTrainingsPassed"));
        });
    };
    var showAverageTrainingsPassed = function () {
        getAverageTrainingsPassed().done(function (data) {
            leaderboard.setData(data.averageTrainingsPassed, $("#lblAverageTrainingsPassed"));
        });
    };
    var showMostTrainingsPassed = function () {
        getMostTrainingsPassed().done(function (data) {
            leaderboard.setData(data.mostTrainingsPassed, $("#lblMostTrainingsPassed"));
            $("#divTrainingsPassed").unblock();
        });
    };

    return {
        getTopUsers: getTopUsers,
        getLeader: getLeader,
        lastYear: lastYear,
        populateContent: populateContent
    };
})();

IREP.leaderboard.legends = (function () {
    var leaderboard = IREP.leaderboard;
    var topCountriesTemplate, topLegendsTemplate;

    var getLongestActiveMembers = function (timeFrame, countryCode, storeChainId) {
        return IREP.callApi("leaderboard/legends/longest-active-members", "GET", { timeFrame: timeFrame, countryCode: countryCode, storeChainId: storeChainId });
    };

    var getLeader = function () {
        return IREP.callApi("leaderboard/legends/leader", "GET");
    };

    var getTopCountriesPassingPercentage = function (timeFrame, storeChainId) {
        return IREP.callApi("leaderboard/legends/top-countries-passing-percentage", "GET", { timeFrame: timeFrame, storeChainId: storeChainId });
    };

    var getTopLegends = function () {
        return IREP.callApi("leaderboard/legends/top-legends", "GET");
    };

    var getStatusLevels = function () {
        return IREP.callApi("leaderboard/legends/status-levels", "GET");
    };

    var populateContent = function () {
        leaderboard.block($("#divStatuslevels_passingpercentage"));
        showStatusLevels();
        showTopCountriesPassingPercentage();
        showTopLegends();
    };

    var showStatusLevels = function () {
        getStatusLevels().done(function (data) {
            var statusLevels = [
                ["Tier", "Count"]
            ];
            $.each(data.statusLevels, function (i, item) {
                statusLevels.push([item.tierName, item.count]);
            });

            var googleData = google.visualization.arrayToDataTable(statusLevels);
            new google.visualization.PieChart(document.getElementById("divStatusLevels")).draw(googleData, {
                title: "",
                backgroundColor: "transparent",
                slices: {
                    0: { color: "#C69633" },
                    1: { color: "#C5C6C8" },
                    2: { color: "#E4AF23" },
                    3: { color: "#ADB0B1" },
                    4: { color: "#F4F5F6" }
                },
                chartArea: {
                    left: 20,
                    top: 0,
                    width: "100%",
                    height: "100%"
                },
                is3D: "true",
                legend: {
                    position: "right",
                    textStyle: {
                        fontSize: 14
                    }
                }
            });
        });
    };
    var showTopCountriesPassingPercentage = function () {
        if (topCountriesTemplate == null) {
            topCountriesTemplate = Handlebars.compile($("#leaderboard-topcountries-passingpercentage-template").html());
        }

        getTopCountriesPassingPercentage().done(function (data) {
            if (data && data.trainings && data.trainings.length > 0) {
                var html = topCountriesTemplate(data.trainings);
                $("#olTopCountriesPassingPercentage").html(html);
            } else {
                leaderboard.noData($("#olTopCountriesPassingPercentage"));
            }
            $("#divStatuslevels_passingpercentage").unblock();
            //var topCountries = [
            //    ["Country", "Passing Percentage"]
            //];

            //$.each(data.trainings, function(i, item) {
            //    topCountries.push([item.name, item.score]);
            //});

            //var googleData = google.visualization.arrayToDataTable(topCountries);

            //var options = {
            //    title: "",
            //    vAxis: {
            //        title: data.countryLabel,
            //        titleTextStyle: {
            //            color: "#238AB6"
            //        }
            //    },
            //    hAxis: {
            //        title: data.passingPercentageLabel,
            //        titleTextStyle: {
            //            color: "#238AB6"
            //        }
            //    },
            //    color: "#238AB6",
            //    legend: { position: "none" },
            //    backgroundColor: "transparent"
            //};

            //var chart = new google.visualization.BarChart(document.getElementById("divTopCountriesPassingPercentage"));
            //chart.draw(googleData, options);
        });
    };
    var showTopLegends = function () {
        if (topLegendsTemplate == null) {
            topLegendsTemplate = Handlebars.compile($("#leaderboard-toplegends-template").html());
        }

        leaderboard.block($("#divTopLegends"));
        getTopLegends().done(function (data) {
            if (data && data.legends && data.legends.length) {
                var html = topLegendsTemplate(data.legends);
                $("#olTopLegends").html(html);
            } else {
                leaderboard.noData($("#olTopLegends"));
            }
            $("#divTopLegends").unblock();
        });
    };

    return {
        getLongestActiveMembers: getLongestActiveMembers,
        getLeader: getLeader,
        populateContent: populateContent
    };
})();